module.exports = __webpack_public_path__ + "static/media/8-7.e65025a5.mp3";